import { Box, Image, Tag, Tooltip } from '@chakra-ui/react';
import { RuleValidationInputValue } from '@client/graphql/__generated__/types';
import { FC, memo } from 'react';

interface FieldImageBoxProps {
  mappingKey: string;
  image: string;
  inputValues?: (RuleValidationInputValue | undefined)[];
  onClick?: () => void;
}

export const FieldImageBox: FC<FieldImageBoxProps> = memo(
  function FieldImageBox({ mappingKey, image, inputValues, onClick }) {
    const rawValue = inputValues?.find((iv) => iv?.fieldKey === mappingKey)
      ?.value;

    // For multi-field arrays (like signatures), parse and show only the first value
    let displayValue = rawValue;
    if (typeof rawValue === 'string' && rawValue.startsWith('[')) {
      try {
        const parsed: unknown = JSON.parse(rawValue);
        if (Array.isArray(parsed) && parsed.length > 0) {
          // Check if it's a multi-field value array with {fieldUuid, value} structure
          const firstItem: unknown = parsed[0];
          if (
            typeof firstItem === 'object' &&
            firstItem !== null &&
            'value' in firstItem
          ) {
            const itemValue = (firstItem as { value?: string }).value;
            displayValue = itemValue || '<empty>';
          }
        }
      } catch {
        // Not valid JSON, use as-is
      }
    }

    return (
      <Box
        bgColor="white"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="sm"
        cursor="pointer"
        mb={2}
        mt={4}
        p={2}
        position="relative"
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
      >
        <Tag
          bgColor="white"
          borderColor="gray.300"
          borderWidth="1px"
          boxShadow="none"
          fontSize="xs"
          mb={2}
          position="absolute"
          right={0}
          top={-5}
          variant="outline"
        >
          {displayValue}
        </Tag>
        <Tooltip
          hasArrow
          bg="compliance.tooltip.bg"
          color="compliance.tooltip.text"
          fontSize="xs"
          label={mappingKey}
          placement="top"
        >
          <Image height="20px" objectFit="contain" src={image} width="auto" />
        </Tooltip>
      </Box>
    );
  }
);
